import { useContext } from 'react';

import AddressesContext from './AddressesContext';

const useAddresses = () => {
  return useContext(AddressesContext);
};

export default useAddresses;
